// this is included in staging environments as a base for settings, so they do not need to be duplicated
export const baseStagingEnvironment = {
    envName: '',
    production: true,
    apiUrl: '',
    loadBalancerApiUrl: '',
    gMapApiKey: 'AIzaSyCjJ40YjyKPJnOGmXoMl97FwRddv5hS2pg',
    s3Env: 'https://staging-cdn.icamppro.com/',
    s3AssetEnv: 'https://staging-assets.icamppro.com/',
    S3DynamicStyles: 'https://icamppro-staging-dynamic-styles.s3.amazonaws.com/', 
    sentryDSN: 'https://89ae45989ec142379c88914802bbd246@o64452.ingest.sentry.io/4505348087414784',
    humanSecuritySensorKey: 'PXhRTqxQp4',
};
